import React from 'react';
import MUIDataTable from "mui-datatables";
import { GET } from "../../../queries/network";
import Delete from './delete';
import { graphql } from 'react-apollo';
import DrawerPlacements from '../../../components/DrawerPlacements';
import { Grid } from '@material-ui/core';
import PageError from '../../../components/PageError';
import PageLoading from '../../../components/PageLoading';
import PageTitle from "../../../components/PageTitle/PageTitle";
import AddNetworks from '../../../pages/networks/actions/create';
import UpdateNetworks from '../../../pages/networks/actions/edit';

const networksFunc = ({ data: { networks, loading, error }}) => {
  const options = {
    selectableRows: 'checkbox',
    responsive: "scrollMaxHeight",
    customToolbarSelect: selectedRows => (
      <Delete selectedRows = {selectedRows} networks={networks}/>
    )
  };

  const ActionsRow = (tableMeta) => {
    const id = tableMeta.rowData[1];
    const name = tableMeta.rowData[0];
    const description = tableMeta.rowData[2];
    return (
      <Grid container spacing={0}>
        <Grid item xs={6}>
        <DrawerPlacements title="Edit Network" iconButtonAction={false} labeButtonAction={name}>
        <UpdateNetworks id = {id} name = {name} description = {description} ></UpdateNetworks>
        </DrawerPlacements>

        </Grid>
        <Grid item xs={6}>
        </Grid>
      </Grid>
    );
  };
  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <PageTitle title="Networks"/>
        </Grid>
        <Grid item xs={2}>
          <DrawerPlacements title="Network" labeButtonAction="Add">
            <AddNetworks></AddNetworks>
          </DrawerPlacements>
        </Grid>
      </Grid>
      
      {
        (loading) ? <PageLoading /> : 
        (error) ? <PageError /> :
        (
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <MUIDataTable
                title={false}
                data={networks}
                columns={[
                  {
                    label : 'Name',
                    name  : 'name',
                    options: {
                      customBodyRender : (value, tableMeta, updateValue) => { 
                        return (ActionsRow(tableMeta))
                      },
                      empty  : true,
                      filter : true,
                      sort   : true,
                    }
                  },{
                    name    : 'id',
                    options : {
                      display : false
                    }
                  },
                  {
                    label   : 'Description',
                    name    : 'description',
                    options : {
                      display : true
                    }
                  }
                ]}
                options={options}
              />
            </Grid>
          </Grid>
        )
      }
  </>);
}

export const Networks = graphql(GET)(networksFunc);